import React from "react";

const TransferQuoteVehicleCard = ({ transferData, onRequestQuote }) => {
	const { vehicle_img, vehicle_type_name, vehicle_type_des, make, model, max_pax, max_lugg } = transferData;

	return (
		<div className="card mb-4">
			<div style={{ display: "flex", alignItems: "flex-start", gap: "1.25rem", padding: "1rem", flexWrap: "wrap" }}>
				<div
					style={{
						flex: "0 0 auto",
						width: "150px",
						height: "150px",
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
					}}
				>
					<img
						src={vehicle_img}
						alt={vehicle_type_name}
						style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }}
					/>
				</div>
				<div style={{ flex: "1 1 320px", minWidth: 0 }}>
					<div className="d-flex justify-content-between flex-wrap">
						<div>
							<h4 className="mb-1">{vehicle_type_des}</h4>
							<span className="badge light border border-primary text-primary text-uppercase mb-2">
								{vehicle_type_name}
							</span>
							<div className="d-flex align-items-center flex-wrap mt-2" style={{ gap: "1rem" }}>
								<span>
									<i className="fa fa-user text-primary me-1" />
									Upto {max_pax} passengers
								</span>
								<span>
									<i className="fa fa-suitcase text-primary me-1" />
									{max_lugg} Luggage's
								</span>
								<span>
									<strong>Vehicle Type:</strong> {make} {model}
								</span>
							</div>
						</div>
					</div>
					<div className="d-flex justify-content-end mt-3">
						<button type="button" className="btn btn-primary rounded-pill px-4" onClick={onRequestQuote}>
							Request Quote <i className="fa fa-paper-plane ms-2" />
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default TransferQuoteVehicleCard;
